// Arquivo gerado por scripts/generate-sidebar-icon-sprite.mjs.
// Não edite manualmente.

export const SIDEBAR_ICON_SPRITE_PATH = "/media/icons/sidebar-icons.svg?v=3147328dc540"

export const SIDEBAR_ICON_IDS = {
  "accept.svg": "sidebar-icon-accept",
  "api-manage-users.svg": "sidebar-icon-api-manage-users",
  "api-services.svg": "sidebar-icon-api-services",
  "api-users.svg": "sidebar-icon-api-users",
  "api-users2.svg": "sidebar-icon-api-users2",
  "apuracao.svg": "sidebar-icon-apuracao",
  "apuracao2.svg": "sidebar-icon-apuracao2",
  "apuracao3.svg": "sidebar-icon-apuracao3",
  "apuracao4.svg": "sidebar-icon-apuracao4",
  "barchart-svgrepo-com.svg": "sidebar-icon-barchart-svgrepo-com",
  "briefing-agent.svg": "sidebar-icon-briefing-agent",
  "briefing-history.svg": "sidebar-icon-briefing-history",
  "briefing-promotion.svg": "sidebar-icon-briefing-promotion",
  "building.svg": "sidebar-icon-building",
  "cadastro-distribuidores.svg": "sidebar-icon-cadastro-distribuidores",
  "cadastro-lojista-interno.svg": "sidebar-icon-cadastro-lojista-interno",
  "cadastro-lojistas.svg": "sidebar-icon-cadastro-lojistas",
  "cadastro-produtos.svg": "sidebar-icon-cadastro-produtos",
  "cadastro-vendedores.svg": "sidebar-icon-cadastro-vendedores",
  "campaign.svg": "sidebar-icon-campaign",
  "cashback.svg": "sidebar-icon-cashback",
  "check-business-and-finance-svgrepo-com (1).svg": "sidebar-icon-check-business-and-finance-svgrepo-com-1",
  "chip-ai.svg": "sidebar-icon-chip-ai",
  "coupon.svg": "sidebar-icon-coupon",
  "coupon2.svg": "sidebar-icon-coupon2",
  "data-graph-chart-report-svgrepo-com.svg": "sidebar-icon-data-graph-chart-report-svgrepo-com",
  "data-report-svgrepo-com.svg": "sidebar-icon-data-report-svgrepo-com",
  "data-svgrepo-com.svg": "sidebar-icon-data-svgrepo-com",
  "data-trends-svgrepo-com.svg": "sidebar-icon-data-trends-svgrepo-com",
  "devops-dashboard.svg": "sidebar-icon-devops-dashboard",
  "devops-history.svg": "sidebar-icon-devops-history",
  "devops-panel.svg": "sidebar-icon-devops-panel",
  "devops-servers.svg": "sidebar-icon-devops-servers",
  "devops-sprints.svg": "sidebar-icon-devops-sprints",
  "devops-tasks.svg": "sidebar-icon-devops-tasks",
  "devops-team.svg": "sidebar-icon-devops-team",
  "devops-users.svg": "sidebar-icon-devops-users",
  "distribuidor-prioritario.svg": "sidebar-icon-distribuidor-prioritario",
  "document-sheet.svg": "sidebar-icon-document-sheet",
  "document.svg": "sidebar-icon-document",
  "faixa-cep-lojista.svg": "sidebar-icon-faixa-cep-lojista",
  "growth-income-investment-svgrepo-com.svg": "sidebar-icon-growth-income-investment-svgrepo-com",
  "home.svg": "sidebar-icon-home",
  "icon-alerts.svg": "sidebar-icon-icon-alerts",
  "icon-ativacao.svg": "sidebar-icon-icon-ativacao",
  "icon-cadastro.svg": "sidebar-icon-icon-cadastro",
  "icon-listas.svg": "sidebar-icon-icon-listas",
  "icon-logs.svg": "sidebar-icon-icon-logs",
  "icon-positivacao.svg": "sidebar-icon-icon-positivacao",
  "icon-regional.svg": "sidebar-icon-icon-regional",
  "infrapay-historico-vouchers.svg": "sidebar-icon-infrapay-historico-vouchers",
  "infrapay-report.svg": "sidebar-icon-infrapay-report",
  "infrapay.svg": "sidebar-icon-infrapay",
  "inspection-svgrepo-com.svg": "sidebar-icon-inspection-svgrepo-com",
  "interface-control-svgrepo-com.svg": "sidebar-icon-interface-control-svgrepo-com",
  "investment-growth-svgrepo-com.svg": "sidebar-icon-investment-growth-svgrepo-com",
  "lists.svg": "sidebar-icon-lists",
  "lists2.svg": "sidebar-icon-lists2",
  "lojas-quase-churn.svg": "sidebar-icon-lojas-quase-churn",
  "magnifying.svg": "sidebar-icon-magnifying",
  "management.svg": "sidebar-icon-management",
  "market-news-newspaper-svgrepo-com.svg": "sidebar-icon-market-news-newspaper-svgrepo-com",
  "market-trends-svgrepo-com.svg": "sidebar-icon-market-trends-svgrepo-com",
  "master-produto.svg": "sidebar-icon-master-produto",
  "menu-ids-ecoa.svg": "sidebar-icon-menu-ids-ecoa",
  "nota-fiscal.svg": "sidebar-icon-nota-fiscal",
  "pedidos.svg": "sidebar-icon-pedidos",
  "permissions.svg": "sidebar-icon-permissions",
  "permissions2.svg": "sidebar-icon-permissions2",
  "presentation-chart-graph-svgrepo-com.svg": "sidebar-icon-presentation-chart-graph-svgrepo-com",
  "promocoes.svg": "sidebar-icon-promocoes",
  "region.svg": "sidebar-icon-region",
  "remove.svg": "sidebar-icon-remove",
  "report.svg": "sidebar-icon-report",
  "reports.svg": "sidebar-icon-reports",
  "robot-ai-svgrepo-com.svg": "sidebar-icon-robot-ai-svgrepo-com",
  "ruler.svg": "sidebar-icon-ruler",
  "seller-group.svg": "sidebar-icon-seller-group",
  "settings-gear-svgrepo-com.svg": "sidebar-icon-settings-gear-svgrepo-com",
  "settings-svgrepo-com (1).svg": "sidebar-icon-settings-svgrepo-com-1",
  "settings-svgrepo-com (2).svg": "sidebar-icon-settings-svgrepo-com-2",
  "settings.svg": "sidebar-icon-settings",
  "size.svg": "sidebar-icon-size",
  "spreadsheet.svg": "sidebar-icon-spreadsheet",
  "stats-financial-svgrepo-com.svg": "sidebar-icon-stats-financial-svgrepo-com",
  "stock-svgrepo-com (1).svg": "sidebar-icon-stock-svgrepo-com-1",
  "stock-svgrepo-com (2).svg": "sidebar-icon-stock-svgrepo-com-2",
  "store.svg": "sidebar-icon-store",
  "ultimo-preco-estoque.svg": "sidebar-icon-ultimo-preco-estoque",
  "unilever-white.svg": "sidebar-icon-unilever-white",
  "unilever.svg": "sidebar-icon-unilever",
  "arr072.svg": "sidebar-icon-arr072",
} as const

export type SidebarIconFilename = keyof typeof SIDEBAR_ICON_IDS

export const getSidebarIconId = (filename: SidebarIconFilename): string =>
  SIDEBAR_ICON_IDS[filename]
